import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface IState {
  MemberId: number | null;
  MemberTypeId: number | null;
  MemberCodeId: number | null;
  FirstName: string | null;
  LastName: string | null;
  FromAdmitDate: Date | null;
  ToAdmitDate: Date | null;
  FromLastPaidDate: Date | null;
  ToLastPaidDate: Date | null;
  FromCertificationEndsOn: Date | null;
  ToCertificationEndsOn: Date | null;
  FromDOB: Date | null;
  ToDOB: Date | null;
  FirmName: string | null;
  FirmId: number | null;
  City: string | null;
  County: string | null;
  State: string | null;
  Zipcode: number | null;
  PhoneNumber: string | null;
  CellPhoneNumber: string | null;
  FaxNumber: string | null;
  Email: string | null;
  FirmAdminPhoneNumber: string | null;
  FirmAdminName: string | null;
  FirmAdminEmail: string | null;
  Sections: number[] | null;
  ExcludedSections: number[] | null;
  Tags: number[] | null;
  ExcludedTags: number[] | null;
  CurrentPage: number | null;
  SortType: string | null;
  SortBy: string | null;
  Paginate: number | null;
  SectionIn: string[] | null;
  SectionNotIn: string[] | null;
  TagIn: string[] | null;
  TagsNotIn: string[] | null;
}

export const initialState: IState = {
  MemberId: null,
  MemberTypeId: null,
  MemberCodeId: null,
  FirstName: null,
  LastName: null,
  FromAdmitDate: null,
  ToAdmitDate: null,
  FromLastPaidDate: null,
  ToLastPaidDate: null,
  FromCertificationEndsOn: null,
  ToCertificationEndsOn: null,
  FromDOB: null,
  ToDOB: null,
  FirmName: null,
  FirmId: null,
  City: null,
  County: null,
  State: null,
  Zipcode: null,
  PhoneNumber: null,
  CellPhoneNumber: null,
  FaxNumber: null,
  Email: null,
  FirmAdminPhoneNumber: null,
  FirmAdminName: null,
  FirmAdminEmail: null,
  Sections: null,
  Tags: null,
  ExcludedSections: null,
  ExcludedTags: null,
  CurrentPage: null,
  SortType: null,
  SortBy: null,
  Paginate: null,
  SectionIn: [],
  SectionNotIn: [],
  TagIn: [],
  TagsNotIn: [],
};

type BodyType = {
  key: string;
  value: string | number[] | string[];
};

type Name = {
  key: string;
  value: string[];
};
export const searchMemberApiSlice = createSlice({
  name: "searchMemberApiSlice",
  initialState,
  reducers: {
    updateSearchBody: (state: any, action: PayloadAction<BodyType>) => {
      console.log("SEARCH:", action.payload.key, ":", action.payload.value);
      state[action.payload.key] = action.payload.value;
    },
    resetSearchParameters: () => initialState,
    executeSearchBody: (state: any, action: PayloadAction<IState>) => {
      return action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { updateSearchBody, resetSearchParameters, executeSearchBody } =
  searchMemberApiSlice.actions;

export default searchMemberApiSlice.reducer;
